import React, {FC, useState} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {H5, Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {Chip} from "@irati/ui/src/MultiChipsSelect/styled"
import theme from "@irati/ui/src/global/theme"
import {OAuthProvider} from "@irati/types"
import adminTracking from "@irati-tracking/admin"

import EnableOauth, {OAuthSettings} from "../EnableSSO/EnableOAuth"
import DeleteSSOModal from "./DeleteSSOModal"
import LoginViaEmailPassword from "./LoginViaEmailPassword"
import EditDomains from "./EditDomains"
import {EditHeader} from "."

const SSO_EDIT = "SSO_editSSO"
const SSO_DELETE = "SSO_deleteSSO"

interface Props {
  provider: OAuthProvider
  domains: string[]
  onClose: () => void
  onSave: (data?: OAuthSettings) => void
  onDelete: () => void
}

const EditOauth: FC<Props> = ({provider, domains, onClose, onSave, onDelete}) => {
  const [edit, setEdit] = useState<boolean>(false)
  const [modal, setModal] = useState<boolean>(false)

  const startEditJourney = () => {
    adminTracking.editIntegrationSSOJourney(SSO_EDIT)
    setEdit(true)
  }

  const openDeleteModal = () => {
    adminTracking.editIntegrationSSOJourney(SSO_DELETE)
    setModal(true)
  }

  const closeDeleteModal = () => {
    setModal(false)
    onDelete()
  }

  return (
    <>
      {!edit ? (
        <>
          <EditHeader />
          <H5 marginBottom={1}>
            <FormattedMessage id="admin.components.integration.sso.editSSO.edit.title" />
          </H5>
          <Body marginBottom={2}>
            <FormattedMessage id="admin.components.integration.sso.editSSO.edit.subtitle" />
          </Body>
          <Flex justifyContent="space-between" marginBottom={3}>
            <Chip readOnly>
              <Body color={theme.colors.filterChip}>{provider}</Body>
            </Chip>
            <div>
              <Button id="settingsIntegration_OAUTH_editSSO_edit_button" marginRight={2} onClick={startEditJourney}>
                <FormattedMessage id="admin.components.integration.sso.editSSO.edit.btn" />
              </Button>
              <Button id="settingsIntegration_OAUTH_editSSO_delete_button" onClick={openDeleteModal} destructive>
                <FormattedMessage id="admin.components.integration.sso.editSSO.edit.deleteBtn" />
                <Icon marginLeft={1} icon={IconTypes.delete} marginRight />
              </Button>
            </div>
          </Flex>
          <H5 marginBottom={1}>
            <FormattedMessage id="admin.components.integration.sso.editSSO.edit.domainsTitle" />
          </H5>
          <Body marginBottom={2}>
            <FormattedMessage id="admin.components.integration.sso.editSSO.edit.domainsSubTitle" />
          </Body>
          <EditDomains provider={provider} items={domains} />
          <LoginViaEmailPassword />
          <div>
            <Button id="settingsIntegration_OAUTH_editSSO_done_button" onClick={() => onClose()} primary>
              <FormattedMessage id="admin.components.integration.sso.editSSO.edit.doneBtn" />
            </Button>
          </div>
        </>
      ) : (
        <EnableOauth onBack={() => setEdit(false)} onClose={(data) => onSave(data)} />
      )}
      <DeleteSSOModal show={modal} onClose={() => setModal(false)} onDelete={closeDeleteModal} />
    </>
  )
}

export default EditOauth
